<script lang="ts">
	import { classes } from '$lib/utils';
	import { getTranslate, T } from '@tolgee/svelte';
	import type { Lesson } from '$lib/types/hygraph';
	import { browser } from '$app/environment';

	const { t } = getTranslate();

	export let lesson: Lesson;
	const description = lesson.description;
	const furtherReading = lesson.furtherReading;
	export let additionalClass = '';
</script>

<div
	class={classes(additionalClass, '')}
	data-elb="lesson"
	data-elbaction="load:viewed "
	data-elb-lesson="lesson_name:{lesson?.name};lesson_slug:{browser ? window.location.pathname : ''}"
	data-elbcontext="lesson_name:{lesson?.name};lesson_slug:{browser ? window.location.pathname : ''}"
>
	{#if description}
		<h2 class="text-xl font-normal">{@html $t('lesson-page.subline')}</h2>
		<h3 class="mt-4 text-base font-normal max-w-12">{description}</h3>
	{/if}
	{#if furtherReading}
		<h3 class="mt-4 text-lg font-normal max-w-12">
			<T keyName="lesson_further_reading_headline" />
		</h3>
		<div class="mt-4 text-base font-normal max-w-12">{@html furtherReading}</div>
	{/if}
</div>
